// Scripts Loaded in Footer
(function($){
	// Initialize each block on page load (front end).
	$(document).ready(function(){
		if($('#acf-form-data').length > 0){
			removeDuplicateIds();
		}
		if($('#afpcustomuserprofile').length > 0){
			removeDuplicateIds();
		}
		if($('#afpuserpassword').length > 0){
			removeDuplicateIds();
		}
		if($('#afpuserprofile').length > 0){
			removeDuplicateIds();
		}
	});

	function removeDuplicateIds(){
		$('#_acf_screen').each(function(e){
			$(this).removeAttr('id');
		});
		$('#_acf_post_id').each(function(e){
			$(this).removeAttr('id');
		});
		$('#_acf_validation').each(function(e){
			$(this).removeAttr('id');
		});
		$('#_acf_form').each(function(e){
			$(this).removeAttr('id');
		});
		$('#acf-form').each(function(e){
			$(this).removeAttr('id');
		});
		$('#_acf_nonce').each(function(e){
			$(this).removeAttr('id');
		});
		$('#_acf_changed').each(function(e){
			$(this).removeAttr('id');
		});
		$('#acf-_validate_email').each(function(e){
			$(this).removeAttr('id');
		});
		$('#userid').each(function(e){
			$(this).removeAttr('id');
		});
		$('#firstname').each(function(e){
			$(this).removeAttr('id');
		});
		$('#lastname').each(function(e){
			$(this).removeAttr('id');
		});
	}
	
	$(document).ready(function(){
		// Sponsor Popup
		$(".sponsor_popup").on("click", function(event){
			event.preventDefault();

			var userparent = $(this).attr("data-id");
			if($("body").find("#afp-core-ajax-loading").length == 0){
				$("body").append('<div id="afp-core-ajax-loading"></div><div id="afp-core-ajax-overlay"><div id="afp-core-ajax-popup"></div></div>');
			}

			$("#afp-core-ajax-loading").show();

			var ajaxCall = afpSendCoreAjax("afp_sponsor_popup", {userparent:userparent});
			ajaxCall.done(function(response) {
				var result = JSON.parse( response );
				if(result.status == 'success') {
					$("#afp-core-ajax-loading").hide();
					$("#afp-core-ajax-popup").html(result.content);
					$("#afp-core-ajax-overlay").show();
				}
			} );
		});

		// reset password form toggle
		$(".afp_passlink").on("click", function(event){
			event.preventDefault();

			$(".logincontainer").toggle();
			$(".resetpasswordcontainer").toggle();
		});

		// login form toggle
		$(".afp_loginlink").on("click", function(event){
			event.preventDefault();

			$(".logincontainer").toggle();
			$(".resetpasswordcontainer").toggle();
		});

		// reset password form
		$("form[name=userresetpassword]").on("submit", function(event){
			var $this = this;
			var email_address = $($this).find("input:text[name=email_address]").val();
			var message = "";

			if(email_address == ""){
				message = "Please enter the email address.";
				$($this).find("input:text[name=email_address]").focus();
			}else if(!validateEmail(email_address)){
				message = "Please enter a valid email address.";
				$($this).find("input:text[name=email_address]").focus();
			}

			if(message == ""){
				$($this).find(".message1").html("");
				$($this).find(".message1").hide();
			}else{
				$($this).find(".message1").html("<span class='afperror'>"+message+"</span>");
				$($this).find(".message1").show();
				event.preventDefault();
			}
		});

		// Sponsor Popup Close
		$("body").on("click", ".afp-core-ajax-popup-close", function(event){
			event.preventDefault();
			$("#afp-core-ajax-loading").remove();
			$("#afp-core-ajax-overlay").remove();
		});
	});

	//login form
	$("form[name=afpuserlogin]").on("submit", function(){
		var $this = this;
		var username = $($this).find("input:text[name=username]").val();
		var userpass = $($this).find("input:password[name=userpass]").val();
		var message = "";

		if(username == ""){
			message = "Please enter the username or email.";
			$($this).find("input:text[name=username]").focus();
		}else if(userpass == ""){
			message = "Please enter the password.";
			$($this).find("input:password[name=userpass]").focus();
		}

		if(message !== ""){
			$($this).find(".message1").html("<span class='afperror'>"+message+"</span>");
			$($this).find(".message1").show();

			event.preventDefault();
		}else{
			$($this).find(".message1").html("");
			$($this).find(".message1").hide();
		}
	});
})(jQuery);

// Capture Valuation
function validateEmail($email) {
	var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
	return emailReg.test( $email );
}